import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Avatar,
  Typography,
  IconButton,
  FormControl,
  Paper,
  TextField,
  InputAdornment,
  InputLabel,
  Select,
  MenuItem,
  Fab} from '@material-ui/core';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import ItemTabelaApi from '../../../api/ItemTabelaApi';
import DeleteIcon from '@material-ui/icons/Delete';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';
import Search from '@material-ui/icons/Search';
import { withAplicacao } from '../../../contexts/AplicacaoContext';

const styles = theme => ({
  dialogTitleTypography: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    display: 'inline',
    fontSize: 23
  },
  dialogTitle: {
    display: 'inline-flex',
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12,
    display: 'inline-flex',
  },
  paperTable: {
    // maxHeight: '35vh'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
  },
  textFieldCodigo: {
    marginLeft: theme.spacing(1),
    width: 250,
    marginTop: theme.spacing(1.5),
  },
  textFieldDescricao: {
    marginLeft: theme.spacing(1),
    width: 450,
    marginTop: theme.spacing(1),
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  searchIcon: {
    marginLeft: theme.spacing(1),
  },
  selectTabela: {
    marginLeft: theme.spacing(2),
    margin: theme.spacing(1),
    width: 250,
  },
  selectTipo: {
    margin: theme.spacing(1),
    width: 400,
  },
  fontTableRed: {
    fontSize: 13,
    color: 'red',
  },
  typographyInfo: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  fontTableLink: {
    fontSize: 14,
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline'
  },

});
const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '5px',
        },
      },
    }
  });
class FormDialogItemEspecifico extends React.Component {
  itemTabelaApi = new ItemTabelaApi();
  state = {
    codItem: '',
    desItem: '',
    itens: [],
    tabelas: [],
    tipos: [],
    codTabelaSelected: 0,
    codTipoSelected: 0,
    fetching: false,
    buscarDisabled: true,
    rowsSelected: [],
    codTabelaSelected: 0,
    desTabelaSelected: '',
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarTabelas();
    await this.consultarTiposDeItem();
    this.setState({fetching: false});
  }
  consultarTabelas = async () => {
    let tabelas = await this.props.getItemTabelaTabelas();
    this.setState({tabelas: tabelas});
  }
  consultarTiposDeItem = async () => {
    let tipos = await this.props.getItemTabelaTipos();
    this.setState({tipos: tipos});
  }
  consultarItens = async () => {
    let itens = [];
      itens = await this.itemTabelaApi.consultarItensRecurso(this.state.codTabelaSelected,
        this.state.codItem === '' ? 'vazio' : this.state.codItem,
        this.state.desItem === '' ? 'vazio' : this.state.desItem,
        this.state.codTipoSelected, 'N');
    this.setState({itens: itens});
  }
  handleClose = () => {
    this.props.handleClose();
  }
  handleChangeTextFieldCodigo = event => {
    var valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 11);
    this.setState({ [event.target.name]: valorNovo });
  };
  handleChangeTextFieldDescricao = event => {
    var valorNovo = event.target.value.toUpperCase().substring(0, 20);
    this.setState({ [event.target.name]: valorNovo });
  };
  handleClickTrashCodigo = () => {
    this.setState({ codItem: '' });
  };
  handleClickTrashDescricao = () => {
    this.setState({ desItem: '' });
  };
  handleClickBuscar = async (event) => {
    this.setState({fetching: true});
    event.preventDefault();
    await this.consultarItens();
    this.setState({fetching: false});
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  isBuscarDisabled = () => {
    return (this.state.codTabelaSelected === 0 || this.state.codTipoSelected === 0) &&
            (this.state.codTabelaSelected === 0 || this.state.codItem === '') &&
            (this.state.codTabelaSelected === 0 || this.state.desItem === '');
  }
  handleChangeTextFieldCodigo = event => {
    var valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 11);
    this.setState({ [event.target.name]: valorNovo });
  };
  handleChangeTextFieldDescricao = event => {
    var valorNovo = event.target.value.toUpperCase().substring(0, 20);
    this.setState({ [event.target.name]: valorNovo });
  };
  handleClickTrashCodigo = () => {
    this.setState({ codItem: '' });
  };
  handleClickTrashDescricao = () => {
    this.setState({ desItem: '' });
  };
  handleClickBuscar = async (event) => {
    this.setState({fetching: true});
    event.preventDefault();
    await this.consultarItens();
    this.setState({fetching: false});
  }

  handleClickSave = async () => {
    let itensEspecificos = [];
    let brancoAcoes = '';
    for (var i = 0; i < this.state.rowsSelected.length; i++) {
      let itemEspecifico = {
        codTabela: this.state.itens[this.state.rowsSelected[i]][10],
        desTabela: this.state.itens[this.state.rowsSelected[i]][3],
        codTipoItem: this.state.itens[this.state.rowsSelected[i]][11],
        desTipoItem: this.state.itens[this.state.rowsSelected[i]][2],
        codItem: this.state.itens[this.state.rowsSelected[i]][0],
        desItem: this.state.itens[this.state.rowsSelected[i]][1],
        codItemTabela: this.state.itens[this.state.rowsSelected[i]][9],
        codItemTaxa: 0,
        codItemTaxaItemTabela: 0,
      }
      itensEspecificos.push(itemEspecifico);
    }
    let itensEspecificosExtract = [];
    itensEspecificos.map(res => {
      const { codTabela, desTabela, codTipoItem, desTipoItem, codItem, desItem, codItemTabela, codItemTaxa, codItemTaxaItemTabela } = res;      
      itensEspecificosExtract.push(Object.values({ codTabela, desTabela, codTipoItem, desTipoItem, codItem, desItem, brancoAcoes, codItemTabela, codItemTaxa, codItemTaxaItemTabela }));
      });      
    this.props.handleSave(itensEspecificosExtract);
  }  
  render () {
    const options = {
      customToolbarSelect: () => {},
      print: false,
      download: false,
      selectableRows: 'multiple',
      rowsSelected: this.state.rowsSelected,
      onRowsSelect: (rowsSelected, allRows) => {
         const selected = allRows.map(item => item.dataIndex);
         this.setState({rowsSelected: selected});
      },
      filterType: 'dropdown',
      rowsPerPageOptions: [10, 50, 100],
      rowsPerPage: 10,
      viewColumns: false,
      filter: false,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>tipo(s) selecionado(s)</Typography>
        },
      }
    };
    const columns = [
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Descrição',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return(
            <Typography
              className={classes.fontTable}
              title='Clique no link para trocar o item...'
              //onClick={event => this.handleClickItem(event, tableMeta)}
              >
                {value}
              </Typography>        
            );
          }
        }
      },
      {
        name: 'Tipo',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Tabela',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Capitulo',
        options: {
          display: 'excluded',
          filter: false,
        },
      },
      {
        name: 'Grupo',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Sub-Grupo',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'vigencias',
        options: {
          display: 'excluded',
          filter: false,
        },
      },
      {
        name: 'Observação',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'codItemTabela',
        options: {
          display: 'excluded',
          filter: false,
        },
      },
      {
        name: 'codTabela',
        options: {
          display: 'excluded',
          filter: false,
        },
      },
      {
        name: 'codTipoItem',
        options: {
          display: 'excluded',
          filter: false,
        },
      },
    ];
    const { open, titulo, classes, handleClose } = this.props;
    const { fetching, itens, tabelas, tipos, codTabelaSelected, codTipoSelected } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='xl'
          scroll='body'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleTypography}>{titulo}</Typography> 
            <Avatar className={classes.avatar}>{itens.length}</Avatar>
          </DialogTitle>
          <DialogContent>
          <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTabela}>
                * Tabela
              </InputLabel>
              <Select
                className={classes.selectTabela}
                value={codTabelaSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTabelaSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODAS</MenuItem>
                {tabelas.map((tabela, idx) => {
                  return (<MenuItem key={idx} value={tabela.id}>{tabela.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                value={(this.state.codItem === null || this.state.codItem === undefined) ? '' : this.state.codItem}
                className={classes.textFieldCodigo}
                margin='dense'
                id='codItem'
                name='codItem'
                placeholder='Pesquise pelo Código...'
                fullWidth
                onChange={this.handleChangeTextFieldCodigo}
                InputProps={{
                  endAdornment: (
                    <InputAdornment variant='filled' position='end'>
                      <IconButton
                        disabled={this.state.codItem === ''}
                        title='Limpar'
                        onClick={this.handleClickTrashCodigo}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                value={(this.state.desItem === null || this.state.desItem === undefined) ? '' : this.state.desItem}
                placeholder='Pesquise pela Descrição...'
                className={classes.textFieldDescricao}
                onChange={this.handleChangeTextFieldDescricao}
                id='desItem'
                name='desItem'
                InputProps={{
                  endAdornment: (
                    <InputAdornment variant='filled' position='end'>
                      <IconButton
                        disabled={this.state.desItem === ''}
                        title='Limpar'
                        onClick={this.handleClickTrashDescricao}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipo}>
                Tipo
              </InputLabel>
              <Select
                className={classes.selectTipo}
                value={codTipoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {tipos.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <Fab
              disabled={this.isBuscarDisabled()}
              variant='extended'
              title='Consultar'
              type='submit'
              onTouchStart={this.handleClickBuscar}
              onClick={this.handleClickBuscar}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Fab>
            <Typography className={classes.typographyInfo}>* Favor selecionar a tabela e preencher mais um filtro</Typography>
          </form>
        </Paper>

            {fetching ? <LinearProgressBlockScreen />
              : <Paper className={classes.paperTable}>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={itens}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </Paper>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.state.rowsSelected.length === 0}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withAplicacao(withStyles(styles)(FormDialogItemEspecifico));
